const pnr = '/assets/torres/homepage/pnr.svg';
const email = '/assets/ivergrama/General/email-icon.svg';
const PopupIcon = '/assets/ivergrama/gallery/gallery5.jpg';


const Banner = '/assets/torres/homepage/home-icons-banner.webp';
const BookingActive = '/assets/ivergrama/Home/buy-ticket.svg';
const BookingInActive = '/assets/ivergrama/Home/buy-ticket.svg';
const CancelActive = '/assets/ivergrama/Home/cancel-ticket.svg';
const CancelInActive = '/assets/ivergrama/Home/cancel-ticket.svg';

const ChangeActive = '/assets/ivergrama/Home/change-ticket.svg'
const ChangeInactive = '/assets/ivergrama/Home/change-ticket.svg'
const CuponeraActive = '/assets/ivergrama/Home/cuponera.svg';
const CuponeraInActive = '/assets/ivergrama/Home/cuponera.svg';
const ConfirmCuponeraActive =
	'/assets/ivergrama/Home/confirm-cuponera.svg';
const ConfirmCuponeraInActive =
	'/assets/ivergrama/Home/confirm-cuponera.svg';

const OriginIcon = '/assets/torres/searchbar/origin.svg';
const DestinationIcon = '/assets/torres/searchbar/destination.svg';
const CalendarIcon = '/assets/torres/searchbar/calendar.svg';
// const SearchIcon = '/assets/ivergrama/Home/Ivergrama-Website-Home-SearchBar-SearchIcon.svg';
const titleUnderline = '/assets/torres/homepage/website-titles.svg';

const sendBtn = '/assets/torres/homepage/sendform.svg';
const contactFormImg = '/assets/torres/homepage/about.webp';

const fb = '/assets/torres/contactus/fb.svg';
const instagram = '/assets/torres/contactus/ins.svg';

const instagramHover = '/assets/torres/contactus/ins.svg';
const fbHover = '/assets/torres/contactus/fb.svg';
const twitter = '/assets/torres/contactus/ins.svg';
const twitterHover =
	'/assets/ivergrama/General/twitter-hover.svg';
const contactfb = '/assets/torres/homepage/footfb.svg';
const contactfbhover = '/assets/torres/homepage/footfb.svg';
const contactinsta = '/assets/torres/homepage/footins.svg';
const contactinstahover = '/assets/torres/homepage/footins.svg';

// const LocationIcon = '/assets/ivergrama/general/LocationIcon.svg';
// const PhoneIcon = '/assets/ivergrama/general/PhoneIcon.svg';
// const HeaderLogo = '/assets/ivergrama/general/Header-BusesTepualLogo.svg';
// const FooterLogo = '/assets/ivergrama/general/Footer-BusesTepualLogo.svg';

const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const BottomFooterKuposLogo = '/assets/common/Footer-kuposLogo.svg';
const animation = '/assets/torres/homepage/animation.gif';


const contactMail = '/assets/torres/contactus/email.svg';
const contactPhone = '/assets/torres/contactus/phone.svg';

const servicesBanner = '/assets/torres/homepage/banner-nuestros-servicios.png';

const aboutUsImage = '/assets/torres/banners/about-small.webp';
// banners
const destinationBanner = '/assets/ivergrama/destinations/destination-main.jpg';
const serviceBanner = '/assets/torres/banners/service.webp';
const faqBanner = '/assets/torres/banners/faq.webp';
const contactUsBanner = '/assets/torres/banners/contact.webp';
const aboutUsBanner = '/assets/torres/banners/about.webp';
const tncBanner = '/assets/torres/banners/terms.webp';
const officeBanner = '/assets/ivergrama/offices/offices-banner.jpg';

const OfficePhoneIcon = '/assets/torres/contactus/email.svg';

const success = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-CheckMark-Gray.svg';
const failure = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Information-Gray.svg';

const tick = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Tick-Gray.svg';
const heartOn = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-HeartOn-Gray.svg';
const heartOff = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-HeartOff-Gray.svg';
const downArrow = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-DropDown-Gray.svg';
const registrationSuccess =
	'/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RightDocument-Gray.svg';
const userIcon = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Login-Gray.svg';
const trips = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-MyTrips-Gray.svg';
const cards = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-MyCards-Gray.svg';
const wallet = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const transaction = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-ShareMoney-Gray.svg';
const otp = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RestorePassword-Gray.svg';

const paso_1 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const paso_2 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargePoints-Gray.svg';
const paso_3 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-ID-Gray.svg';
const paso_4 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Tickets-Gray.svg';

//  pet seat
const petseatref =
	'/assets/ivergrama/pet/Ivergrama-ResultPage-SeatPick-PetsOnBoard_Pet Paw Icon (Amenite).svg';
const petseatModal = '/assets/ivergrama/pet/PopUp.png';
const petfilteroff = '/assets/ivergrama/pet/Ivergrama-ResultPage-PetsOnBoard-Button-Filter_off.svg';
const petfilteron = '/assets/ivergrama/pet/Ivergrama-ResultPage-PetsOnBoard-Button-Filter_On.svg';

const operatorPay = '/assets/ivergrama/iverpay.png';
const whiteDownArrow = 'assets/ivergrama/Home/Down-arrow.svg';
const tncDownArrow = 'assets/torres/banners/arrow.svg';
const accordOpen = 'assets/centropuerto/Preguntas/P.frecuentes-active.png';
const accordClose = 'assets/centropuerto/Preguntas/P.frecuentes-inactive.png';
const torresIcons = [

	{ icon: downArrow, name: 'downArrow' },
	{ icon: tncDownArrow, name: 'tncDownArrow' },

	{ icon: whiteDownArrow, name: 'whiteDownArrow' },
	{ icon: accordOpen, name: 'accordOpen' },
	{ icon: accordClose, name: 'accordClose' },

	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },

	{ icon: paso_1, name: 'paso_1' },
	{ icon: paso_2, name: 'paso_2' },
	{ icon: paso_3, name: 'paso_3' },
	{ icon: paso_4, name: 'paso_4' },

	// { icon: PhoneIcon, name: 'phone' },
	{ icon: email, name: 'email' },
	// { icon: LocationIcon, name: 'location' },
	// { icon: HeaderLogo, name: 'headerLogo' },
	// { icon: FooterLogo, name: 'footerLogo' },
	{ icon: contactFormImg, name: 'contactFormImg' },
	{ icon: titleUnderline, name: 'titleUnderline' },


	{ icon: contactPhone, name: 'contactPhone' },
	{ icon: sendBtn, name: 'sendBtn' },
	{ icon: fb, name: 'fb' },
	{ icon: fbHover, name: 'fbHover' },
	{ icon: contactfb, name: 'contactfb' },
	{ icon: contactfbhover, name: 'contactfbhover' },
	{ icon: contactinsta, name: 'contactinsta' },
	{ icon: contactinstahover, name: 'contactinstahover' },
	{ icon: instagram, name: 'instagram' },
	{ icon: instagramHover, name: 'instagramHover' },

	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: twitter, name: 'twitter' },
	{ icon: twitterHover, name: 'twitterHover' },

	{ icon: BookingActive, name: 'BA' },
	{ icon: BookingInActive, name: 'BIA' },
	{ icon: CancelActive, name: 'CA' },
	{ icon: CancelInActive, name: 'CIA' },
	{ icon: ChangeActive, name: 'CTA' },
	{ icon: ChangeInactive, name: 'CTIA' },
	{ icon: CuponeraActive, name: 'CUA' },
	{ icon: CuponeraInActive, name: 'CUIA' },
	{ icon: ConfirmCuponeraActive, name: 'CCA' },
	{ icon: ConfirmCuponeraInActive, name: 'CCIA' },
	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: CalendarIcon, name: 'Calendar' },
	// { icon: SearchIcon, name: 'Search' },
	{ icon: PopupIcon, name: 'Popup' },
	{ icon: checkboxIcon, name: 'Checkbox' },
	{ icon: BottomFooterKuposLogo, name: 'BottomFooterKuposLogo' },
	{ icon: animation, name: 'animation' },
	{ icon: pnr, name: 'pnr' },
	{ icon: OfficePhoneIcon, name: 'OfficePhoneIcon' },

	{ icon: contactMail, name: 'contactMail' },
	// { icon: contactAddress, name: 'contactAddress' },
	{ icon: destinationBanner, name: 'destinationBanner' },
	{ icon: faqBanner, name: 'faqBanner' },
	{ icon: serviceBanner, name: 'serviceBanner' },
	{ icon: contactUsBanner, name: 'contactUsBanner' },
	{ icon: aboutUsImage, name: 'aboutUsImage' },
	{ icon: aboutUsBanner, name: 'aboutUsBanner' },
	{ icon: tncBanner, name: 'tncBanner' },
	{ icon: officeBanner, name: 'officeBanner' },
	{ icon: Banner, name: 'Banner' },
	//  pet seat
	{ icon: petseatref, name: 'petseatref' },
	{ icon: petseatModal, name: 'petseatModal' },
	{ icon: petfilteron, name: 'petfilteron' },
	{ icon: petfilteroff, name: 'petfilteroff' },
	{ icon: operatorPay, name: 'operatorPay' },

	{ icon: servicesBanner, name: 'servicesBanner' },
];

export default torresIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/torresIcons.js